var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1782_29113)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1782_29113",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 121,
    height: 120
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.52588e-05H120.5V120H0.5V1.52588e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1782_29113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.6515 23.5408C82.9609 25.6029 97.1909 41.1394 97.1909 59.9997C97.1909 80.2638 80.7638 96.6909 60.4998 96.6909C40.2357 96.6909 23.8083 80.2638 23.8083 59.9997C23.8083 41.1558 38.0141 25.6296 56.3005 23.5462",
    stroke: "#DB4D29",
    strokeWidth: 1.91406,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2341 15.9302C69.6332 18.5369 73.3211 19.525 76.7022 18.4671C81.8118 16.8682 87.1968 19.9774 88.367 25.2018C89.1412 28.6589 91.8409 31.3586 95.298 32.1328C100.522 33.303 103.632 38.688 102.033 43.7976C100.975 47.1787 101.963 50.8666 104.57 53.2657C108.509 56.8912 108.509 63.1092 104.57 66.735C101.963 69.134 100.975 72.8219 102.033 76.203C103.632 81.3126 100.522 86.6976 95.298 87.8676C91.8409 88.642 89.1412 91.3418 88.367 94.7988C87.1968 100.023 81.8118 103.132 76.7022 101.533C73.3211 100.475 69.6332 101.463 67.2341 104.07C63.6086 108.01 57.3904 108.01 53.7648 104.07C51.3658 101.463 47.6779 100.475 44.2968 101.533C39.1872 103.132 33.8022 100.023 32.6322 94.7988C31.8578 91.3418 29.1581 88.642 25.701 87.8676C20.4766 86.6976 17.3674 81.3126 18.9665 76.203C20.0245 72.8219 19.0361 69.134 16.4294 66.735C12.49 63.1092 12.49 56.8912 16.4294 53.2657C19.0361 50.8666 20.0245 47.1787 18.9665 43.7976C17.3674 38.688 20.4766 33.303 25.701 32.1328C29.1581 31.3586 31.8578 28.6589 32.6322 25.2018C33.8022 19.9774 39.1872 16.8682 44.2968 18.4671C47.6779 19.525 51.3658 18.5369 53.7648 15.9302C57.3904 11.9906 63.6086 11.9906 67.2341 15.9302Z",
    stroke: "#DB4D29",
    strokeWidth: 1.91406,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.253 1.75764L103.551 16.4604",
    stroke: "#DB4D29",
    strokeWidth: 1.91406,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.902 27.0781L118.254 25.0726",
    stroke: "#DB4D29",
    strokeWidth: 1.91406,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7766 9.10938L94.7822 1.75797",
    stroke: "#DB4D29",
    strokeWidth: 1.91406,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74438 1.75764L17.4472 16.4604",
    stroke: "#DB4D29",
    strokeWidth: 1.91406,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0958 27.0781L2.74438 25.0726",
    stroke: "#DB4D29",
    strokeWidth: 1.91406,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2226 9.10938L26.217 1.75797",
    stroke: "#DB4D29",
    strokeWidth: 1.91406,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.253 118.242L103.551 103.539",
    stroke: "#DB4D29",
    strokeWidth: 1.91406,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.902 92.9222L118.254 94.9277",
    stroke: "#DB4D29",
    strokeWidth: 1.91406,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7766 110.891L94.7822 118.242",
    stroke: "#DB4D29",
    strokeWidth: 1.91406,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74438 118.242L17.4472 103.539",
    stroke: "#DB4D29",
    strokeWidth: 1.91406,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0958 92.9222L2.74438 94.9277",
    stroke: "#DB4D29",
    strokeWidth: 1.91406,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2226 110.891L26.217 118.242",
    stroke: "#DB4D29",
    strokeWidth: 1.91406,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3101 66.931L83.7338 52.5073C85.1741 51.0671 85.1741 48.7322 83.7338 47.292L79.2008 42.759C77.7605 41.3187 75.4255 41.3187 73.9852 42.759L54.8703 61.8739L47.3745 54.3781C45.9343 52.9379 43.5992 52.9379 42.159 54.3781L37.265 59.2723C35.8248 60.7126 35.8248 63.0476 37.265 64.4876L49.8038 77.0267C52.4026 79.6252 56.6157 79.6252 59.2144 77.0267L63.537 72.7041",
    stroke: "#DB4D29",
    strokeWidth: 1.91406,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1782_29113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.3ae1d06268dd0734abbab307d4138ef9.svg";
export { ForwardRef as ReactComponent };